export default __webpack_public_path__ + "ccef71f945684b6a6c3b90bf6087dc49.png";